import styled, { css } from 'styled-components';

import { Typography } from '@speeki/global-ui-components';

import { breakpoints } from '@shared/constants';

export const Message = styled(Typography.TextBody_16_24)`
    ${({ theme: { palette } }) => css`
        background: ${palette.neutral.gray};
        margin-bottom: 16px;
    `}
`;

export const SkeletonFileWrapper = styled.div`
    margin-bottom: 10px;
`;

export const ReportUploadFiles = styled.div`
    ${({ theme: { palette, radius } }) => css`
        background: ${palette.neutral.gray};
        border-radius: ${radius[8]}px;
        display: flex;
        flex-direction: column;
        margin-left: 30px;
        padding: 55px 50px;

        @media (max-width: ${breakpoints.md}px) {
            margin: 30px 0 0 0;
            padding: 25px;
        }
    `}
`;

export const SkeletonBoxTitle = styled.div`
    margin-bottom: 25px;
`;
